var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.312988 23.8979L10.3738 18.0227L20.4606 23.8979V35.7013L10.3738 41.603L0.312988 35.7013V23.8979Z",
    stroke: "#DC4D04",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.312988 23.8979L10.3738 29.7996",
    stroke: "#DC4D04",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3735 29.7996L20.4604 23.8979",
    stroke: "#DC4D04",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3735 29.7996V41.8412",
    stroke: "#DC4D04",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4604 23.8979L30.5212 18.0227L40.582 23.8979V35.7013L30.5212 41.603L20.4604 35.7013V23.8979Z",
    stroke: "#DC4D04",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4604 23.8979L30.5212 29.7996",
    stroke: "#DC4D04",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.521 29.7996L40.5818 23.8979",
    stroke: "#DC4D04",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.521 29.7996V41.8412",
    stroke: "#DC4D04",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3735 6.27219L20.4604 0.370483L30.5212 6.27219V18.0756L20.4604 23.9773L10.3735 18.0756V6.27219Z",
    stroke: "#DC4D04",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3735 6.27216L20.4604 12.1739",
    stroke: "#DC4D04",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4604 12.1739L30.5212 6.27216",
    stroke: "#DC4D04",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4604 12.1739V24.2155",
    stroke: "#DC4D04",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8947,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/product-icon.abb5dc5fd20b83e706cb8f241dbfea11.svg";
export { ForwardRef as ReactComponent };